"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lexBotSchema = exports.accountLexBotSchema = exports.LexBotType = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
var LexBotType;
(function (LexBotType) {
    LexBotType["LegacyBot"] = "Legacy bot";
    LexBotType["SearchAndMessageBot"] = "Search & Message Bot (cb_message_search_only)";
    LexBotType["CustomBot"] = "Custom bot";
})(LexBotType || (exports.LexBotType = LexBotType = {}));
exports.accountLexBotSchema = yup_lib_1.default
    .mixed()
    .oneOf(Object.values(LexBotType))
    .required()
    .label('Lex Bot Type');
exports.lexBotSchema = yup_lib_1.default.object().shape({
    lexbot: yup_lib_1.default.string().oneOf(Object.values(LexBotType)).required()
});
